export type AudioMood =
  | 'deep_drone'
  | 'quantum_flutter'
  | 'subharmonic_pulse'
  | 'caesura_silence'
  | 'synaptic_alarm';

export interface AudioCue {
  mood: AudioMood;
  intensity: number;       // 0.0 to 1.0
  subharmonicBass: number; // 0.0 to 1.0
  dissonance: number;      // 0.0 to 1.0
  glitchFrequency: number; // 0.0 to 1.0
}

export interface AudioController {
  updateAudioCue(cue: AudioCue): void;
  triggerPageTurnSound(): void;
  setMasterVolume(val: number): void; // 0.0 to 1.0
  toggleMute(): boolean;
  unlockAudio(): Promise<boolean>;
  isMuted(): boolean;
  isUnlocked(): boolean;
  getVolume(): number;
}

export const DEFAULT_AUDIO_CUE: AudioCue = {
  mood: 'deep_drone',
  intensity: 0.4,
  subharmonicBass: 0.5,
  dissonance: 0.1,
  glitchFrequency: 0.0,
};
